export const buildUnifiedDisposalBoard = (mixes = [], cycleRepaymentTable = []) => {
  const mergedBoard = [];

  let totalInterestReturn = 0;
  let totalReturn = 0;
  let totalAdditionalFee = 0;

  let maxMonthlyReturn = 0;
  let minMonthlyReturn = 0;

  const maxLoanPeriodLength = Math.max(
    mixes[0]?.disposalBoard.length || 0,
    cycleRepaymentTable.length || 0,
  );

  for (let i = 0; i < maxLoanPeriodLength; i += 1) {
    const cycle = cycleRepaymentTable[i];
    const mix = mixes[0]?.disposalBoard[i];

    const monthlyInterestReturn = (cycle?.total?.interest || 0)
        + (mix?.monthlyInterestReturn || 0);

    const monthlyFundReturn = (cycle?.total?.principal || 0)
        + (mix?.monthlyFundReturn || 0);

    const totalMonthlyReturn = (cycle?.total?.totalPayment || 0)
        + (mix?.totalMonthlyReturn || 0);

    const additionalFee = (cycle?.total?.linkage || 0)
        + (mix?.additionalAmountDueToAdditionalFee || 0);

    const fundBalance = (mix?.fundBalance || 0) + (cycle?.total?.remainingPrincipal || 0);
    totalInterestReturn += monthlyInterestReturn;
    totalReturn += totalMonthlyReturn;
    totalAdditionalFee += additionalFee;

    maxMonthlyReturn = Math.max(maxMonthlyReturn, totalMonthlyReturn);
    minMonthlyReturn = Math.min(minMonthlyReturn, totalMonthlyReturn);

    mergedBoard.push({
      period: i + 1,
      totalMonthlyReturn,
      monthlyInterestReturn,
      monthlyFundReturn,
      additionalAmountDueToAdditionalFee: additionalFee,
      fundBalance,
    });
  }

  const returnConversion = totalInterestReturn ? totalReturn / totalInterestReturn : 0;

  return {
    disposalBoard: mergedBoard,
    maxMonthlyReturn,
    minMonthlyReturn,
    returnConversion,
    risk: 0,
    totalAdditionalAmountDueToAdditionalFee: totalAdditionalFee,
    totalInterestReturn,
    totalReturn,
  };
};
